import { Checkbox, FormControlLabel } from '@material-ui/core';
import { getCategoryLabel } from './templateCategories';
import { Filter } from './Filter';

export type CategoryFilterProps = {
  allCategories: string[];
  selectedCategories: string[];
  onToggle: (type: string) => void;
};

export const CategoryFilter = (props: CategoryFilterProps) => {
  const { allCategories, selectedCategories, onToggle } = props;
  if (allCategories.length === 0) {
    return null;
  }

  const sortedTypes = [...allCategories].sort((a, b) =>
    getCategoryLabel(a).localeCompare(getCategoryLabel(b)),
  );

  return (
    <Filter label="Categories">
      {sortedTypes.map(type => (
        <FormControlLabel
          key={type}
          control={
            <Checkbox
              checked={selectedCategories.includes(type)}
              onChange={() => onToggle(type)}
              size="small"
            />
          }
          label={getCategoryLabel(type)}
        />
      ))}
    </Filter>
  );
};
